import { render, staticRenderFns } from "./QuoList.vue?vue&type=template&id=0ca98601&"
import script from "./QuoList.vue?vue&type=script&lang=js&"
export * from "./QuoList.vue?vue&type=script&lang=js&"
import style0 from "./QuoList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports